<div class="title">
  <mat-icon [svgIcon]="sectionOptions.icon"></mat-icon>
  <h2>{{ sectionOptions.title | translate }}</h2>
</div>
<div class="container">
  <div *ngIf="sectionOptions.lang" class="translation-banner">
    <span class="banner-lang">{{ sectionOptions.lang.source | uppercase }}</span>
    <mat-icon svgIcon="icv_actionable_language"></mat-icon>
    <span class="banner-lang">{{ sectionOptions.lang.target | uppercase }}</span>
  </div>
  <ng-content></ng-content>
</div>
